import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon, ButtonProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import DownloadIcon from "@tCentro/Icons/DownloadIcon";
import NISCompareIcon from "@tCentro/Icons/NISCompareIcon";
import NISDownloadIcon from "@tCentro/Icons/NISDownloadIcon";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: NISDownloadContainerStyles;
}
const enum fields {
    showCompare = "showCompare",
    visibilityState = "visibilityState",
    icon = "icon",
    link = "link",
    includeAccountMenu = "includeAccountMenu",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.showCompare]: boolean;
        [fields.visibilityState]: string;
        [fields.icon]: string;
        [fields.includeAccountMenu]: boolean;
        [fields.link]: LinkFieldValue;
    };
}

export interface NISDownloadContainerStyles {
    downloadVerticalIconWrapper?: InjectableCss;
    downloadIconWrapper?: InjectableCss;
    titleTypography?: TypographyPresentationProps;
}

export const nisDownloadContainerStyles: NISDownloadContainerStyles = {
    downloadIconWrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            // margin: 0px 8px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    downloadVerticalIconWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
            background: none !important;
            border: none !important;
            gap: 4px;
            // width: 48px;
            // height: 48px;
            min-height: 0px;
            border-radius: 40px;
            padding: 0px;
            &:focus {
                outline-style: none !important;
            }
            &:hover {
                border-color: unset !important;
            }
            // &:hover {

            //     svg {
            //         path {
            //             fill: ${COLORS.white};
            //         }
            //     }
            // }
        `,
    },
    titleTypography: {
        css: css`
            margin-left: 0;
            margin-top: 0;
            color: ${getColor("primary")};
            text-transform: capitalize;
            font-size: ${TYPOGRAPHY.size.base};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: 16px;
            font-family: Roboto;
            @media (min-width: 1080px) and (max-width: 1340px) {
                font-size: 12px;
                font-weight: 700;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        // display: none;
                    `,
                    css`
                        // display: none;
                    `,
                    css`
                        // display: none;
                    `,
                    css`
                        @media (min-width: 993px) and (max-width: 1079px) {
                            // display: none;
                        }
                    `,
                ]);
            }}
        `,
        // ellipsis: true,
        // transform: "uppercase",
    },
};

const styles = nisDownloadContainerStyles;

const NISDownloadContainer: FC<OwnProps> = ({ id, fields }) => {
    const showIcon = fields.visibilityState === "both" || fields.visibilityState === "icon";
    const showLabel = fields.visibilityState === "both" || fields.visibilityState === "label";
    return (
        <StyledWrapper {...styles.downloadIconWrapper}>
            <Button onClick={() => window.print()} {...styles.downloadVerticalIconWrapper}>
                {showIcon && <Icon size={20} src={NISDownloadIcon} title={"Print"} />}
                {showLabel && <Typography {...styles.titleTypography}>{siteMessage("NIS Print")}</Typography>}
            </Button>
        </StyledWrapper>
    );
};

const nisdownloadContainer: WidgetModule = {
    component: NISDownloadContainer,
    definition: {
        group: "Product Details",
        fieldDefinitions: [
            {
                name: fields.visibilityState,
                displayName: "Settings",
                editorTemplate: "RadioButtonsField",
                options: [
                    {
                        displayName: "Both",
                        value: "both",
                    },
                    {
                        displayName: "Show Label",
                        value: "label",
                    },
                    {
                        displayName: "Show Icon",
                        value: "icon",
                    },
                ],
                defaultValue: "both",
                fieldType: "General",
                sortOrder: 1,
            },
        ],
    },
};

export default nisdownloadContainer;
